import { useEffect, useState } from 'react';
import { useApiInfoContextValueHook } from '../../../contexts/ApiInfoContextProvider';
import { useQueryParamsHook } from '../../../hooks/useQueryParamsHook';
import * as St from './index.styled';
import { SellertoolSignatureUtils } from '../../../utils/sellertool-signature-utils';
import axios from 'axios';
import { customToast } from '../../../components/toast/custom-react-toastify/v1';
import { CustomDialog } from '../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../components/input/CustomLabelInput';
import CustomBlockButton from '../../../components/button/CustomBlockButton';
import { CustomBackdropController } from '../../../components/backdrop/default/v1';

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export function MainView(props) {
    const queryParamsHook = useQueryParamsHook();

    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [warehousingItems, setWarehousingItems] = useState(null);
    const [productOptions, setProductOptions] = useState(null);

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        handleReqFetchWarehousingItems();
    }, [apiInfoContextValueHook?.apiInfo?.apiKey, apiInfoContextValueHook?.apiInfo?.secretKey]);

    useEffect(() => {
        if (!warehousingItems || warehousingItems?.length <= 0) {
            return;
        }

        handleReqFetchProductOptions();
    }, [warehousingItems])

    const handleReqFetchWarehousingItems = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const params = {
            status: 'SCAN_COMPLETED'
        }

        const warehousingItemsResult = await axios.get(`${API_HOST}/warehousing-items`, {
            headers: headers,
            params: params
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                if (err?.response) {
                    customToast.error(err?.response?.data?.message);
                } else {
                    customToast.error(`undefined error`)
                }
            })

        if (warehousingItemsResult?.content) {
            setWarehousingItems(warehousingItemsResult?.content);
        }
    }

    const handleReqFetchProductOptions = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const optionCodeSet = new Set();

        warehousingItems?.forEach(item => {
            let optionCode = item?.optionCode;

            if (!optionCode || !optionCode.trim() || optionCodeSet.has(optionCode)) {
                return;
            }
            optionCodeSet.add(item?.optionCode);
        })
        const body = {
            optionCodes: [...optionCodeSet]
        }

        const productOptionssResult = await axios.post(`${API_HOST}/product-options/by-optionCodes`, body, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                if (err?.response) {
                    customToast.error(err?.response?.data?.message);
                } else {
                    customToast.error(`undefined error`)
                }
            })

        if (productOptionssResult?.content) {
            setProductOptions(productOptionssResult?.content);
        }
    }
    return (
        <>
            <ListMode
                warehousingItems={warehousingItems}
                productOptions={productOptions}
                onReqFetchWarehousingItems={handleReqFetchWarehousingItems}
            />
        </>
    );
}

function ListMode({
    warehousingItems,
    productOptions,
    onReqFetchWarehousingItems
}) {
    const [selectedItems, setSelectedItems] = useState([]);
    const [editModeModalOpen, setEditModeModalOpen] = useState(false);
    const [deleteModeModalOpen, setDeleteModeModalOpen] = useState(false);

    const productCount = warehousingItems?.length;
    const totalCTNCount = warehousingItems?.reduce((prev, current) => (Number(prev) + Number(current?.boxQuantity)), 0);

    useEffect(() => {
        if (!warehousingItems) {
            return;
        }

        handleRefreshSelectedItems();
    }, [warehousingItems]);

    const handleRefreshSelectedItems = () => {
        const newItems = [];

        selectedItems?.forEach(selectedItem => {
            let newItem = warehousingItems?.find(r => r.id === selectedItem?.id);
            if (newItem) {
                newItems.push(newItem);
            }
        })
        setSelectedItems(newItems)
    }

    const handleSelectItem = (item) => {
        setSelectedItems(prev => {
            if (prev.find(r => r.id === item.id)) {
                return prev.filter(r => r.id !== item.id);
            }
            return [...prev, item]
        });
    }

    const handleSelectAllItems = () => {
        if (selectedItems?.length === warehousingItems?.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(warehousingItems);
        }
    }

    const handleEditModeModalOpen = () => {
        setEditModeModalOpen(true);
    }

    const handleEditModeModalClose = () => {
        setEditModeModalOpen(false);
    }

    const handleDeleteModeModalOpen = () => {
        setDeleteModeModalOpen(true);
    }

    const handleDeleteModeModalClose = () => {
        setDeleteModeModalOpen(false);
    }

    return (
        <>
            <St.ListMode.Container>
                <St.ListMode.CountBox>
                    <div>
                        총 CTN 수 : {totalCTNCount}
                    </div>
                    <div>
                        총 상품수 : {productCount}
                    </div>
                </St.ListMode.CountBox>
                <St.ListMode.EventButtonBox>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleEditModeModalOpen()}
                    >선택수정</CustomBlockButton>
                    <div className='countBox'>{selectedItems?.length} 개 선택됨</div>
                    <CustomBlockButton
                        type='button'
                        className='delete'
                        onClick={() => handleDeleteModeModalOpen()}
                    >선택삭제</CustomBlockButton>
                </St.ListMode.EventButtonBox>
                <St.ListMode.TableBox>
                    <table>
                        <thead>
                            <tr>
                                <th width={50}>
                                    <input
                                        type='checkbox'
                                        checked={selectedItems?.length === warehousingItems?.length}
                                        onChange={() => handleSelectAllItems()}
                                        onClick={(e) => e.stopPropagation()}
                                    ></input>
                                </th>
                                <th
                                    width={200}
                                    style={{ background: '#f0f0f0' }}
                                >셀러툴 상품명</th>
                                <th
                                    width={200}
                                    style={{ background: '#f0f0f0' }}
                                >셀러툴 옵션명</th>
                                <th
                                    width={200}
                                    style={{ background: '#f0f0f0' }}
                                >셀러툴 옵션코드</th>
                                <th width={200}>입고예정 수량</th>
                                <th width={200}>입고 옵션코드</th>
                                <th width={200}>입고리스트 상품명</th>
                                <th width={200}>입고리스트 옵션명</th>
                                <th width={200}>박스 수량</th>
                                <th width={200}>운송장번호</th>
                                <th width={200}>합배송코드</th>
                            </tr>
                        </thead>
                        <tbody>
                            {warehousingItems?.map(warehousingItem => {
                                const productOption = productOptions?.find(r => r.productOptionCode === warehousingItem?.optionCode);
                                const isSelected = selectedItems?.find(r => r.id === warehousingItem?.id) ? true : false;
                                return (
                                    <tr
                                        key={warehousingItem?.id}
                                        onClick={() => handleSelectItem(warehousingItem)}
                                    >
                                        <td width={50}>
                                            <input
                                                type='checkbox'
                                                checked={isSelected}
                                                onChange={() => { handleSelectItem(warehousingItem); }}
                                                onClick={(e) => { e.stopPropagation(); }}
                                            ></input>
                                        </td>
                                        <td
                                            style={{ background: '#f0f0f0' }}
                                        >
                                            {productOption?.productName || '-'}
                                        </td>
                                        <td
                                            style={{ background: '#f0f0f0' }}
                                        >
                                            {productOption?.productOptionName || '-'}
                                        </td>
                                        <td
                                            style={{ background: '#f0f0f0' }}
                                        >
                                            {productOption?.productOptionCode || '-'}
                                        </td>
                                        <td>{warehousingItem?.productQuantity}</td>
                                        <td>{warehousingItem?.optionCode || '-'}</td>
                                        <td>{warehousingItem?.warehousingProductName}</td>
                                        <td>{warehousingItem?.warehousingOptionName}</td>
                                        <td>{warehousingItem?.boxQuantity}</td>
                                        <td>{warehousingItem?.waybillNumber}</td>
                                        <td>{warehousingItem?.mergingCode}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </St.ListMode.TableBox>
            </St.ListMode.Container>

            {(editModeModalOpen) &&
                <EditModeModal
                    open={editModeModalOpen}
                    onClose={handleEditModeModalClose}
                    selectedItems={selectedItems}
                    onReqFetchWarehousingItems={onReqFetchWarehousingItems}
                />
            }

            {(deleteModeModalOpen) &&
                <DeleteModeModal
                    open={deleteModeModalOpen}
                    onClose={handleDeleteModeModalClose}
                    selectedItems={selectedItems}
                    onReqFetchWarehousingItems={onReqFetchWarehousingItems}
                />
            }
        </>
    );
}

function EditModeModal({
    open,
    onClose,
    selectedItems,
    onReqFetchWarehousingItems
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const [editTargetItems, setEditTargetItems] = useState([...selectedItems]);

    const handleChangeNumberValue = (e, itemId) => {
        const name = e.target.name;
        const value = e.target.value;

        const regex = /^[0-9]{0,6}$/

        if (!regex.test(value)) {
            return;
        }

        setEditTargetItems(prev => {
            return prev.map(r => {
                if (r.id === itemId) {
                    return {
                        ...r,
                        [name]: Number(value)
                    }
                } else {
                    return { ...r }
                }
            })
        })
    }

    const handleChangeTextValue = (e, itemId) => {
        const name = e.target.name;
        const value = e.target.value;

        setEditTargetItems(prev => {
            return prev.map(r => {
                if (r.id === itemId) {
                    return {
                        ...r,
                        [name]: value
                    }
                } else {
                    return { ...r }
                }
            })
        })
    }

    const handleSubmitUpdate = async () => {
        const bodyContent = editTargetItems?.map(r => {
            return {
                ...r,
                waybillNumber: r?.waybillNumber ? r?.waybillNumber?.trim() : '',
                mergingCode: r?.mergingCode ? r?.mergingCode?.trim() : '',
                optionCode: r?.optionCode ? r?.optionCode?.trim() : '',
                warehousingProductName: r?.warehousingProductName ? r?.warehousingProductName?.trim() : '',
                warehousingOptionName: r?.warehousingOptionName ? r?.warehousingOptionName?.trim() : '',
                productQuantity: (!r?.productQuantity || r?.productQuantity <= 0) ? 0 : r?.productQuantity,
                boxQuantity: (!r?.boxQuantity || r?.boxQuantity <= 0) ? 0 : r?.boxQuantity,
            }
        });

        const body = {
            warehousingItems: bodyContent
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const updateResult = await axios.put(`${API_HOST}/warehousing-items`, body, {
            headers: headers
        })
            .then(res => {
                if (res.status === 200) {
                    return {
                        res: res,
                        content: res.data.content
                    }
                } else {
                    return {
                        res: res,
                        content: null
                    };
                }

            })
            .catch(err => {
                if (err?.response) {
                    customToast.error(err?.response?.data?.message);
                } else {
                    customToast.error(`undefined error`)
                }
            });
        CustomBackdropController().hideBackdrop();

        if (updateResult?.content) {
            onReqFetchWarehousingItems();
            onClose();
        }
    }
    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
                maxWidth='lg'
            >
                <St.EditModeModal.HeaderContainer>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>입고리스트 수정</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </St.EditModeModal.HeaderContainer>
                <St.EditModeModal.BodyContainer>
                    <St.EditModeModal.TableBox>
                        <table>
                            <thead>
                                <tr>
                                    <th width={200}>입고 옵션코드</th>
                                    <th width={200}>입고리스트 상품명</th>
                                    <th width={200}>입고리스트 옵션명</th>
                                    <th width={200}>입고예정 수량</th>
                                    <th width={200}>박스 수량</th>
                                    <th width={200}>운송장번호</th>
                                    <th width={200}>합배송코드</th>
                                </tr>
                            </thead>
                            <tbody>
                                {editTargetItems?.map(warehousingItem => {
                                    return (
                                        <tr key={warehousingItem?.id}>
                                            <td>
                                                <input
                                                    type='text'
                                                    name='optionCode'
                                                    value={warehousingItem?.optionCode || ''}
                                                    onChange={(e) => handleChangeTextValue(e, warehousingItem?.id)}
                                                >
                                                </input>
                                            </td>
                                            <td>
                                                <input
                                                    type='text'
                                                    name='warehousingProductName'
                                                    value={warehousingItem?.warehousingProductName || ''}
                                                    onChange={(e) => handleChangeTextValue(e, warehousingItem?.id)}
                                                >
                                                </input>
                                            </td>
                                            <td>
                                                <input
                                                    type='text'
                                                    name='warehousingOptionName'
                                                    value={warehousingItem?.warehousingOptionName || ''}
                                                    onChange={(e) => handleChangeTextValue(e, warehousingItem?.id)}
                                                >
                                                </input>
                                            </td>
                                            <td>
                                                <input
                                                    type='number'
                                                    name='productQuantity'
                                                    step={1}
                                                    value={warehousingItem?.productQuantity || ''}
                                                    onChange={(e) => handleChangeNumberValue(e, warehousingItem?.id)}
                                                >
                                                </input>
                                            </td>
                                            <td>
                                                <input
                                                    type='number'
                                                    name='boxQuantity'
                                                    step={1}
                                                    value={warehousingItem?.boxQuantity || ''}
                                                    onChange={(e) => handleChangeNumberValue(e, warehousingItem?.id)}
                                                >
                                                </input>
                                            </td>
                                            <td>
                                                <input
                                                    type='text'
                                                    name='waybillNumber'
                                                    value={warehousingItem?.waybillNumber || ''}
                                                    onChange={(e) => handleChangeTextValue(e, warehousingItem?.id)}
                                                >
                                                </input>
                                            </td>
                                            <td>
                                                <input
                                                    type='text'
                                                    name='mergingCode'
                                                    value={warehousingItem?.mergingCode || ''}
                                                    onChange={(e) => handleChangeTextValue(e, warehousingItem?.id)}
                                                >
                                                </input>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </St.EditModeModal.TableBox>
                    <St.EditModeModal.FooterBox>
                        <CustomBlockButton
                            type='button'
                            onClick={() => handleSubmitUpdate()}
                        >
                            수정완료
                        </CustomBlockButton>
                    </St.EditModeModal.FooterBox>
                </St.EditModeModal.BodyContainer>
            </CustomDialog>
        </>
    );
}

function DeleteModeModal({
    open,
    onClose,
    selectedItems,
    onReqFetchWarehousingItems
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const handleSubmitDelete = async () => {
        if (!selectedItems || selectedItems?.length <= 0) {
            alert('선택된 데이터가 없습니다.');
            return;
        }
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            warehousingItemIds: selectedItems?.map(r => r.id)
        }
        CustomBackdropController().showBackdrop();
        const deleteResult = await axios.delete(`${API_HOST}/warehousing-items/bulk`, {
            data: body,
            headers: headers
        })
            .then(res => {
                if (res.status === 200) {
                    return {
                        res: res,
                        content: res.data.content
                    }
                } else {
                    return {
                        res: res,
                        content: null
                    }
                }
            })
            .catch(err => {
                if (err?.response) {
                    customToast.error(err?.response?.data?.message);
                } else {
                    customToast.error(`undefined error`)
                }
            })
            ;
        CustomBackdropController().hideBackdrop();
        if (deleteResult?.content) {
            onReqFetchWarehousingItems();
            onClose();
        }
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
            >
                <St.DeleteModeModal.HeaderContainer>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>선택 데이터 삭제</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </St.DeleteModeModal.HeaderContainer>
                <St.DeleteModeModal.BodyContainer>
                    <div className='notice'>총 {selectedItems?.length} 개의 데이터를 삭제 합니다.</div>
                </St.DeleteModeModal.BodyContainer>
                <St.DeleteModeModal.FooterBox>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleSubmitDelete()}
                    >삭제</CustomBlockButton>
                </St.DeleteModeModal.FooterBox>
            </CustomDialog>
        </>
    );
}